import { createContext } from 'react'

export const AnalyticsContext = createContext({
	updateAnalyticsListingData: () => { console.warn('Analytics context not set!') },
	sendGtagEvent: () => { console.warn('Analytics context not set!') },
});